const r = "Pressione Tab para acessar o pop-over", t = {
  triggerHint: r
};
export {
  t as default,
  r as triggerHint
};
